import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ExpandableHtml } from '@bibliocommons/expandable';
import { sendAnalyticsEvents } from '@bibliocommons/utils-analytics';
import { bibMetadataEventComposer } from '@bibliocommons/analytics-event-composers';
import AnalyticsConstants from '@bibliocommons/constants-analytics';
import Heading from '@bibliocommons/heading';

const { composeReadMoreEvent } = bibMetadataEventComposer;
const { CUSTOM_DIMENSIONS } = AnalyticsConstants;

function handleReadMoreClick(expanded) {
  sendAnalyticsEvents(
    composeReadMoreEvent({
      expanded,
      gtmContainerName: CUSTOM_DIMENSIONS.CONTAINER_NAMES.BIB_ABOUT_ABOUT_AUTHOR
    })
  );
}

export default class AboutTheAuthor extends React.PureComponent {
  render() {
    const noteText = this.props.authorNote;
    if (!noteText) return null;

    return (
      <div className="cp-about-the-author">
        <Heading tagName="h3" size="medium" variant>
          <FormattedMessage id="about_the_author" />
        </Heading>
        <ExpandableHtml
          htmlText={noteText}
          expandLinkHref="#author-description-read-more"
          dataKey="author-description-read-more-link"
          textKey="about_the_author"
          handleToggle={handleReadMoreClick}
        />
      </div>
    );
  }
}

AboutTheAuthor.propTypes = {
  authorNote: PropTypes.string
};
